import safeURLParse from '@/utils/safeURLParse'

// Firefox has no ancestorOrigins, and the referrer is cut down to the origin by the default
// referrer policy, which still leaves the host.
export function getEmbeddingHostname(): string {
    const ancestors = window.location.ancestorOrigins
    const top = ancestors?.item(ancestors.length - 1) || document.referrer
    return safeURLParse(top)?.hostname || ''
}
